import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from './base-service';
import { CyberAttackRecommendationDto } from '../model/cyber-attack-recommendation-dto';

@Injectable({
    providedIn: 'root'
})
export class CyberAttackRecommendationsService extends BaseService {

    constructor(http: HttpClient, router: Router) {
        super(http, router)
    }

    public getRecommendations(): Promise<CyberAttackRecommendationDto[]> {
        const request = this.get<CyberAttackRecommendationDto[]>('cyber-attack-recommendations');
        return this.apiCall<CyberAttackRecommendationDto[]>(request);
    }

    public updateRecommendation(cyberAttackRecommendationDto: CyberAttackRecommendationDto): Promise<void> {
        const request = this.put<void>('cyber-attack-recommendations', cyberAttackRecommendationDto);
        return this.apiCall<void>(request);
    }
}
